export const getUser = () => {
  const userData = localStorage.getItem("user");
  if (userData !== null) {
    return JSON.parse(userData);
    // console.log(JSON.parse(userData));
  }
  return null;
};

export const getToken = () => {
  const token = localStorage.getItem("token");
  // console.log(token);
  if (token !== null) {
    return token;
  }
  return null;
};

export const userId = () => {
  const userId = localStorage.getItem("cityId");
  if (userId !== null) {
    return userId;
  }
  return null;
};

export const CityId = () => {
  const userId = localStorage.getItem("cityId");
  if (userId !== null) {
    return userId;
  }
  return null;
};

export const setUserCredentials = (user) => {
  const token = user.jwt_token ? user.jwt_token : "";
  const UserId = user.mms_city_id ? user.mms_city_id : "";
  const cityId = user.mms_city_name ? user.mms_city_name : "";

  localStorage.setItem("token", token);
  localStorage.setItem("cityId", UserId);
  localStorage.setItem("cityName", cityId);
  localStorage.setItem("user", user ? JSON.stringify(user) : null);
};

export const removeUserCredentials = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("userId");
  localStorage.removeItem("cityId");
  localStorage.removeItem("cityName");
  localStorage.removeItem("colValue");
  localStorage.removeItem("sortNo");
  // localStorage.clear();
};
export const RemoveSortkeys = () => {
  localStorage.removeItem("colValue");
  localStorage.removeItem("sortNo");
  // localStorage.removeItem("search");
};
